<section class="nav-carousel-container">
	<button type="button" class="back-button" (click)="onBackClick()">
		<mat-icon class="material-symbols-outlined" aria-hidden="true">arrow_back_ios</mat-icon>
		{{ backLabel() }}
	</button>

	@if (showBreadcrumb()) {
		<div class="breadcrumb">{{ breadcrumb() }}</div>
	}

	@if (showCarousel()) {
		<section class="carousel-controls">
			<button
				matIconButton
				aria-label="Zum vorherigen Element"
				matTooltip="Zum vorherigen Element"
				(click)="goToPrevious()"
				[disabled]="isFirst()"
			>
				<mat-icon class="material-symbols-outlined" aria-hidden="true">chevron_left</mat-icon>
			</button>

			<span class="carousel-label">
				{{ currentElement()?.label ?? '-' }}
			</span>

			<button
				matIconButton
				aria-label="Zum nächsten Element"
				matTooltip="Zum nächsten Element"
				(click)="goToNext()"
				[disabled]="isLast()"
			>
				<mat-icon class="material-symbols-outlined" aria-hidden="true">chevron_right</mat-icon>
			</button>
		</section>
	}
</section>
